/* HOMNÈS — Comptoir. L'application du comptoir de la Maison-Atelier.
   Elle remplace la maquette : tout ce qui s'affiche ici vient du serveur.

   Trois sources, une seule porte :
     Shopify  — les clientes, leurs commandes, leurs métachamps
     Zettle   — les tickets de caisse, sans identité, montants réels
     Klaviyo  — l'événement « Passage Boutique », posé à l'enregistrement

   Aucune clé ici. Tout passe par la fonction Apps Script, qui les détient.
   Le code du comptoir est saisi une fois par appareil et reste sur l'appareil. */
(function(){
  const racine = document.getElementById('cpt');
  if(!racine || window.__cptHomnes) return;
  window.__cptHomnes = true;

  const API = racine.dataset.api || '';
  const LIEN_RDV = racine.dataset.rdv || '';
  const CODE_REMISE = racine.dataset.code || '';

  const CLE_CODE   = 'homnes_crm_cle';      /* partagé avec l'ancien comptoir */
  const CLE_LOCAL  = 'homnes_cpt_local';    /* notes, rapprochements, fiches en attente */
  const CLE_BASE   = 'homnes_cpt_base';     /* index des clientes */
  const BASE_DUREE = 12 * 3600 * 1000;

  document.documentElement.classList.add('cpt-ouvert');
  document.body.classList.add('cpt-ouvert');

  /* ── petits outils ─────────────────────────────────────────────────── */
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c =>
    ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const emailOk = e => /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test((e||'').trim());

  function euros(n, devise){
    const v = Number(n || 0);
    try{ return new Intl.NumberFormat('fr-FR',{style:'currency',currency:devise||'EUR'}).format(v); }
    catch(e){ return v.toFixed(2).replace('.',',') + ' €'; }
  }
  function dateCourte(s){
    if(!s) return '';
    try{ return new Date(s).toLocaleDateString('fr-FR',{day:'numeric',month:'short',year:'numeric'}); }
    catch(e){ return String(s).slice(0,10); }
  }
  function ilYA(quand){
    const t = quand instanceof Date ? quand.getTime() : new Date(quand).getTime();
    if(!t || isNaN(t)) return '';
    const s = Math.round((Date.now() - t) / 1000);
    if(s < 60) return "à l'instant";
    const m = Math.round(s / 60);
    if(m < 60) return 'il y a ' + m + ' min';
    const h = Math.floor(m / 60);
    if(h < 24) return 'il y a ' + h + ' h' + (m % 60 ? ' ' + String(m % 60).padStart(2,'0') : '');
    return 'il y a ' + Math.round(h / 24) + ' j';
  }
  function jours(depuis){
    const t = new Date(depuis).getTime();
    if(!t || isNaN(t)) return null;
    return Math.max(0, Math.round((Date.now() - t) / 86400000));
  }
  /* Sans accent, sans casse : « Chloé » se trouve en tapant « chloe ». */
  const SANS_ACCENT = new RegExp('[\\u0300-\\u036f]','g');
  function pli(s){
    s = (s == null ? '' : String(s)).toLowerCase();
    try{ s = s.normalize('NFD').replace(SANS_ACCENT,''); }catch(e){}
    return s;
  }
  function initiales(nom){
    const m = String(nom || '').trim().split(/\s+/).filter(Boolean);
    if(!m.length) return '?';
    return ((m[0][0] || '') + (m.length > 1 ? m[m.length-1][0] : '')).toUpperCase();
  }
  function lire(cle, defaut){
    try{ const v = localStorage.getItem(cle); return v ? JSON.parse(v) : defaut; }
    catch(e){ return defaut; }
  }
  function ecrire(cle, valeur){
    try{ localStorage.setItem(cle, JSON.stringify(valeur)); }catch(e){}
  }

  /* ── la porte : le code du comptoir ────────────────────────────────── */
  function code(){ try{ return localStorage.getItem(CLE_CODE) || ''; }catch(e){ return ''; } }

  /* ── le serveur ────────────────────────────────────────────────────── */
  /* Apps Script n'accepte pas d'en-tête personnalisé sans préflight : on envoie
     du texte simple qui contient du JSON. Rien de sensible dans l'adresse. */
  function api(action, donnees, essai){
    const corps = Object.assign({ action: action, cle: code() }, donnees || {});
    return fetch(API, {
      method:'POST',
      headers:{ 'content-type':'text/plain;charset=utf-8' },
      body: JSON.stringify(corps),
      redirect:'follow'
    }).then(r => r.text().then(txt => {
      let j = null;
      try{ j = JSON.parse(txt); }catch(e){ j = null; }
      /* Google renvoie parfois une page HTML au lieu de la réponse.
         Ce n'est pas une erreur de fond : on redemande une fois. */
      if(j === null){
        if(!essai) return new Promise(ok => setTimeout(ok, 700)).then(() => api(action, donnees, 1));
        throw new Error("Google n'a pas répondu correctement. Réessayez dans un instant.");
      }
      if(j.erreur) throw new Error(j.erreur);
      if(!r.ok) throw new Error('Erreur ' + r.status);
      return j;
    }));
  }

  /* ── l'état ────────────────────────────────────────────────────────── */
  const local = lire(CLE_LOCAL, null) || { tags:{}, notes:{}, fiches:[] };
  local.tags = local.tags || {}; local.notes = local.notes || {}; local.fiches = local.fiches || [];
  function sauverLocal(){ ecrire(CLE_LOCAL, { tags:S.tags, notes:S.notes, fiches:S.fiches }); }

  const S = {
    ouvert: !!code(),
    vue:'comptoir', d:null,
    tags: local.tags, notes: local.notes, fiches: local.fiches,
    noteOuverte:null,
    vente:null, ticketVente:null,
    filtre:'tous', rech:'',
    exp:{ prenom:'', nom:'', email:'', freq:null, consent:false, ticket:null, mode:'apayer' },
    coord:{ prenom:'', nom:'', email:'', consent:false },

    tickets:[], ticketsEtat:'inconnu', ticketsMsg:'', ticketsQuand:0,
    extras:[], numTicket:'', numEtat:'', numMsg:'',
    base:[], baseEtat:'inconnu', baseQuand:0,
    fiche:null, ficheEtat:'inconnu', ficheData:null, ficheErr:'', pourId:null,
    correction:null,
    message:null, occupe:false
  };
  let minuteur = null, rafraichisseur = null;

  const RELANCES = {
    'Tous les jours':'J+38', 'Tous les 2 jours':'J+45', 'Tous les 3 jours':'J+55',
    'Une fois par semaine':'J+80', "Moins d'une fois par semaine":'J+95'
  };

const SOINS = {
  purifiant:        {nom:'Shampoing Purifiant',        sub:'au rhassoul',              desc:'Régule le sébum et purifie le cuir chevelu sans agresser.'},
  nourrissant:      {nom:'Shampoing Nourrissant',      sub:'à la protéine de soie',    desc:"Apaise les tiraillements et restaure l'hydratation en profondeur."},
  antipelliculaire: {nom:'Shampoing Anti-pelliculaire',sub:'au shikakai',              desc:'Cible la levure responsable des pellicules et apaise les démangeaisons.'},
  antichute:        {nom:'Shampoing Anti-chute',       sub:"à l'amla",                 desc:'Renforce la fibre et stimule le cuir chevelu.'},
  normaux:          {nom:'Shampoing Cheveux Normaux',  sub:'au vinaigre de cidre',     desc:"Entretient l'équilibre du cuir chevelu, brillance et douceur."},
  apres:            {nom:"L'Après-shampoing",          sub:'à la protéine de soie',    desc:'Démêle et hydrate la fibre. À appliquer sur les longueurs.'}
};

const PROFILS = {
  purifiant:        {code:'SH+', cc:'Tendance grasse',  sb:'Élevé',            fb:'Saine',        titre:'Cuir chevelu à tendance grasse.'},
  nourrissant:      {code:'CS-', cc:'Sec, sensible',    sb:'Faible',           fb:'Déshydratée',  titre:'Cuir chevelu sec et sensible.'},
  antipelliculaire: {code:'PM',  cc:'Sujet pellicules', sb:'Modéré à élevé',   fb:'À apaiser',    titre:'Cuir chevelu sujet aux pellicules.'},
  antichute:        {code:'CT',  cc:'Fragilisé',        sb:'Variable',         fb:'À renforcer',  titre:'Fibre à renforcer, cuir chevelu à stimuler.'},
  normaux:          {code:'EQ',  cc:'Équilibré',        sb:'Normal',           fb:'Saine',        titre:'Cuir chevelu équilibré.'}
};

const ETIQ = {
  purifiant:'le sébum, les racines grasses', nourrissant:'la sécheresse, les tiraillements',
  antipelliculaire:'les pellicules, les démangeaisons', antichute:'la chute de cheveux'
};

const Q = {
  multi:{et:'Étape 1 · Dépistage', t:"Qu'observez-vous en ce moment ?",
    sub:"Cochez tout ce qui s'applique. Pas de panique, tout est réversible.", type:'multi', k:'checked',
    ops:[['gras','Mes racines regraissent vite'],['sec','Mon cuir chevelu tiraille ou est inconfortable'],
         ['pellicules',"J'ai des pellicules ou des squames"],['demangeaisons',"J'ai des démangeaisons"],
         ['chute',"Je perds plus de cheveux que d'habitude"],['normaux','Rien de tout ça, ou je ne sais pas']]},
  Q2:{et:'Étape 2 · Le lavage', t:'À quelle fréquence lavez-vous vos cheveux ?', type:'un', sk:'Q2',
    ops:[['jour','Tous les jours'],['j2','Tous les 2 jours'],['j3','Tous les 3 jours'],['sem','Une fois par semaine'],['moins',"Moins d'une fois par semaine"]]},
  Q3:{et:'Étape 2 · Le lavage', t:'Et c’est plutôt…', type:'un', sk:'Q3',
    ops:[['regraisse','Parce que ça regraisse, je suis obligée'],['choix','Par choix, je pourrais attendre']]},
  Q4:{et:'Étape 2 · Le lavage', t:'Quand vous espacez, votre cuir chevelu tiraille ou démange ?', type:'un', sk:'Q4',
    ops:[['oui','Oui'],['non','Non'],['jamais',"Je n'espace jamais"]]},

  A1:{et:'Racines grasses', t:'Vos racines redeviennent grasses ou plates…', type:'un', cat:'A', k:'A1',
    ops:[['soir','Le soir même'],['lendemain','Le lendemain'],['j2','À 2 jours'],['j3plus','3 jours et plus']]},
  A2:{et:'Racines grasses', t:'Film gras au toucher, cuir chevelu ou oreiller, en fin de journée ?', type:'un', cat:'A', k:'A2', ops:[['oui','Oui'],['non','Non']]},
  A3:{et:'Racines grasses', t:'Votre zone T du visage, front et nez, est plutôt grasse ?', type:'un', cat:'A', k:'A3', ops:[['oui','Oui'],['non','Non']]},
  A4:{et:'Racines grasses', t:'C’est ainsi depuis toujours, ou c’est récent ?', type:'un', cat:'A', k:'A4',
    ops:[['toujours','Depuis toujours'],['recent','Récent'],['nsp','Je ne sais pas']]},

  B1:{et:'Cuir chevelu sec', t:'Quand vous attendez entre deux lavages, ça…', type:'un', cat:'B', k:'B1',
    ops:[['tiraille','Tiraille ou picote'],['confort','Reste confortable']]},
  B2:{et:'Cuir chevelu sec', t:'Vos démangeaisons, s’il y en a, arrivent juste après le lavage ?', type:'un', cat:'B', k:'B2',
    ops:[['oui','Oui'],['non','Non'],['nsp','Je ne sais pas']]},

  C1:{et:'Pellicules et démangeaisons', t:'Vos démangeaisons montent surtout…', sub:'Plusieurs réponses possibles.', type:'multi', cat:'C', k:'C1',
    ops:[['before','En approchant du prochain shampoing'],['sport','Après le sport, quand je transpire'],
         ['after','Juste après le lavage'],['winter',"L'hiver, ou en période de stress"],['none','Sans lien']]},
  C2:{et:'Pellicules et démangeaisons', t:'Vos squames sont…', type:'un', cat:'C', k:'C2',
    ops:[['grasses','Grasses, jaunâtres, qui collent'],['fines','Fines, sèches, qui volent'],['none','Pas de squames']]},
  C3:{et:'Pellicules et démangeaisons', t:'Avez-vous des rougeurs du cuir chevelu ?', type:'un', cat:'C', k:'C3', ops:[['oui','Oui'],['non','Non']]},
  C4:{et:'Pellicules et démangeaisons', t:'Squames ou rougeurs aussi sur le visage, ailes du nez, sourcils, oreilles ?', type:'un', cat:'C', k:'C4', ops:[['oui','Oui'],['non','Non']]},
  C5:{et:'Pellicules et démangeaisons', t:'Avez-vous déjà eu des pellicules par le passé ?', type:'un', cat:'C', k:'C5',
    ops:[['jamais','Jamais'],['ponctuel','Ponctuellement'],['revient','Oui, ça revient par périodes']]},
  C6:{et:'Pellicules et démangeaisons', t:'Plutôt…', type:'un', cat:'C', k:'C6',
    ops:[['winter',"L'hiver"],['stress','En stress ou fatigue'],['nsp','Sans raison identifiée']]},

  D1:{et:'Perte de cheveux', t:'Les cheveux tombent avec un petit bulbe blanc, ou ce sont des bouts cassés ?',
    sub:'Regardez de près : un cheveu cassé a un bout net, un cheveu tombé a un petit point au bout.', type:'un', cat:'D', k:'D1',
    ops:[['bulbe','Avec un bulbe blanc'],['casses','Bouts cassés']]},
  D2:{et:'Perte de cheveux', t:'Par plaques rondes, ou chute brutale et massive ?', alerte:true, type:'un', cat:'D', k:'D2', ops:[['non','Non'],['oui','Oui']]},
  D3:{et:'Perte de cheveux', t:'Depuis quand ?', type:'un', cat:'D', k:'D3',
    ops:[['6sem','Moins de 6 semaines'],['mois','Quelques mois'],['6m','Plus de 6 mois']]},
  D4:{et:'Perte de cheveux', t:'Un déclencheur il y a deux ou trois mois ?', type:'un', cat:'D', k:'D4',
    ops:[['accouchement','Accouchement'],['stress','Stress fort'],['regime','Régime ou fatigue'],['pilule',"Arrêt de pilule"],['maladie','Maladie ou fièvre'],['rien','Rien']]},
  D5:{et:'Perte de cheveux', t:'La raie s’élargit, la queue de cheval s’affine, ou chute dans la famille ?', type:'un', cat:'D', k:'D5', ops:[['oui','Oui'],['non','Non']]},
  D6:{et:'Perte de cheveux', t:'Avez-vous déjà eu des épisodes de chute auparavant ?', type:'un', cat:'D', k:'D6',
    ops:[['oui','Oui'],['non','Non'],['nsp','Je ne sais pas']]},

  Q5:{et:'Arbitrage', t:'Ce qui vous agace le plus, là, maintenant ?', sub:'On commencera par traiter cette priorité.', type:'un', sk:'priorite', ops:[]}
};

const RELANCES_Q2 = { jour:'J+38', j2:'J+45', j3:'J+55', sem:'J+80', moins:'J+95' };

function dNeuf(){ return {i:0, flow:['multi','Q2','Q3','Q4'], checked:[], Q2:null, Q3:null, Q4:null,
                          priorite:null, A:{}, B:{}, C:{C1:[]}, D:{}}; }

function construireFlow(){
  const d = S.d, c = d.checked;
  const f = ['multi','Q2','Q3','Q4'];
  if(c.includes('gras') || d.Q3 === 'regraisse') f.push('A1','A2','A3','A4');
  if(c.includes('sec')  || d.Q4 === 'oui')       f.push('B1','B2');
  if(c.includes('pellicules') || c.includes('demangeaisons')) f.push('C1','C2','C3','C4','C5');
  if(c.includes('chute')) f.push('D1');
  d.flow = f;
}
function prolongerApres(cle){
  const d = S.d, f = d.flow, i = f.indexOf(cle);
  if(cle === 'C5' && d.C.C5 === 'revient' && !f.includes('C6')) f.splice(i+1, 0, 'C6');
  if(cle === 'D1' && d.D.D1 === 'bulbe'  && !f.includes('D2')) f.splice(i+1, 0, 'D2','D3','D4','D5','D6');
}
function valides(){
  const d = S.d, c = d.checked, v = [];
  if(c.includes('gras') || d.Q3 === 'regraisse') v.push('purifiant');
  if(c.includes('sec')  || d.Q4 === 'oui')       v.push('nourrissant');
  if(c.includes('pellicules') || c.includes('demangeaisons')) v.push('antipelliculaire');
  if(c.includes('chute')) v.push('antichute');
  if(c.includes('normaux')) v.push('normaux');
  if(!v.length) v.push('normaux');
  return [...new Set(v)];
}
function prescription(){
  const v = valides();
  const ordre = ['antipelliculaire','purifiant','antichute','nourrissant'];
  let liste = v.filter(x => x !== 'normaux').sort((x,y) => ordre.indexOf(x) - ordre.indexOf(y));
  if(S.d.priorite && liste.includes(S.d.priorite)) liste = [S.d.priorite, ...liste.filter(x => x !== S.d.priorite)];
  const principal = liste[0] || 'normaux';
  return { valides:v, principal, second:liste[1] || null,
           profil:PROFILS[principal], alerte: S.d.D.D2 === 'oui' };
}
/* Q5 n'a de sens que si plusieurs problèmes coexistent. On l'ajoute au moment
   où la dernière question de branche est répondue, comme le prévoyait le site. */
function poserArbitrage(){
  const d = S.d;
  if(d.flow.includes('Q5')) return;
  const v = valides().filter(x => x !== 'normaux');
  if(v.length < 2) return;
  Q.Q5.ops = v.map(x => [x, ETIQ[x]]);
  d.flow.push('Q5');
}

function repondu(cle){
  const d = S.d, q = Q[cle];
  if(q.type === 'multi') return (q.cat ? (d[q.cat][q.k]||[]) : d[q.k]).length > 0;
  return q.cat ? !!d[q.cat][q.k] : !!d[q.sk];
}

  /* ══════════════════════════════════════════════════════════════════
     Ce qui vient du serveur
     ══════════════════════════════════════════════════════════════════ */

  /* Les tickets de caisse. Zettle ne donne ni nom ni email : seulement
     l'heure, le montant, les articles et le moyen de paiement. */
  function chargerTickets(silencieux){
    if(S.ticketsEtat === 'charge') return;
    S.ticketsEtat = 'charge';
    if(!silencieux) rendre();
    const debut = new Date(Date.now() - 36 * 3600 * 1000).toISOString().slice(0,10);
    api('tickets', { debut: debut, limite: 40 })
      .then(d => {
        if(d.zettle === false){
          S.ticketsEtat = 'absent';
          S.ticketsMsg = d.message || "Zettle n'est pas encore relié.";
          S.tickets = [];
        } else {
          S.ticketsEtat = 'pret';
          S.ticketsMsg = '';
          S.tickets = (d.tickets || []).map(t => ({
            id: t.id, ref: t.ref, heure: t.heure,
            montant: Number(t.montant || 0), devise: t.devise || 'EUR',
            paiement: t.paiement || '', articles: t.articles || []
          }));
          S.ticketsQuand = Date.now();
        }
      })
      .catch(e => { S.ticketsEtat = 'erreur'; S.ticketsMsg = e.message; })
      .then(() => rendre());
  }

  /* Shopify renvoie le nombre de commandes en chaîne de caractères.
     On le ramène à un nombre une fois pour toutes, sinon les filtres mentent. */
  function normaliser(liste){
    return (liste || []).map(c => Object.assign({}, c, {
      commandes: Number(c.commandes || 0),
      _r: c._r || pli((c.nom || '') + ' ' + (c.prenom || '') + ' ' + (c.email || '') + ' ' + (c.telephone || ''))
    }));
  }

  /* L'index des clientes. Chargé une fois, gardé sur l'appareil douze heures,
     filtré sur place : taper devient instantané. */
  function chargerBase(force){
    if(!force && S.baseEtat === 'pret' && S.base.length) return;
    const cache = lire(CLE_BASE, null);
    if(!force && cache && cache.quand && (Date.now() - cache.quand) < BASE_DUREE && cache.clientes){
      S.base = normaliser(cache.clientes); S.baseQuand = cache.quand; S.baseEtat = 'pret';
      return;
    }
    if(S.baseEtat === 'charge') return;
    S.baseEtat = 'charge';
    api('base', {})
      .then(d => {
        S.base = normaliser(d.clientes);
        S.baseQuand = Date.now();
        S.baseEtat = 'pret';
        ecrire(CLE_BASE, { quand:S.baseQuand, clientes:S.base });
      })
      .catch(e => { S.baseEtat = 'erreur'; S.message = { ko:true, t:"La base des clientes n'a pas pu être chargée : " + e.message }; })
      .then(() => rendre());
  }

  function ouvrirFiche(id, nom){
    S.fiche = { id: id, nom: nom };
    S.ficheData = null; S.ficheEtat = 'charge'; S.ficheErr = '';
    S.correction = null;
    S.vue = 'fiche';
    rendre();
    api('fiche', { id: id })
      .then(d => { S.ficheData = d; S.ficheEtat = 'pret'; })
      .catch(e => { S.ficheEtat = 'erreur'; S.ficheErr = e.message; })
      .then(() => rendre());
  }

  /* L'enregistrement. C'est le seul geste qui écrit dans Shopify et Klaviyo. */
  function enregistrer(corps, libelle, apres){
    if(S.occupe) return;
    S.occupe = true;
    dire('Enregistrement en cours…');
    rendre();
    api('passage', corps)
      .then(d => {
        const qui = corps.prenom || corps.email;
        const suite = d.nouvelle ? " Sa fiche vient d'être créée."
                    : d.passage ? " C'est son " + d.passage + "e passage." : '';
        if(d.alerte) dire(d.alerte, false, true);
        else dire(qui + ' ' + libelle + '.' + suite, true);
        /* Une nouvelle cliente doit être trouvable tout de suite. */
        if(d.nouvelle && d.id){
          S.base.unshift({ id:d.id, prenom:corps.prenom || '', nom:((corps.prenom||'') + ' ' + (corps.nom||'')).trim() || corps.email,
                           email:corps.email, telephone:'', commandes:0,
                           _r: pli((corps.prenom||'') + ' ' + (corps.nom||'') + ' ' + corps.email) });
          ecrire(CLE_BASE, { quand:S.baseQuand || Date.now(), clientes:S.base });
        }
        if(apres) apres(d);
      })
      .catch(e => dire("Enregistrement impossible : " + e.message + " Rien n'a été perdu, réessayez.", false, true))
      .then(() => { S.occupe = false; rendre(); });
  }

  /* ══════════════════════════════════════════════════════════════════
     Ce qui se calcule sur l'appareil
     ══════════════════════════════════════════════════════════════════ */

  const ticketPose  = t => S.tags[t.id];
  const enAttente   = () => S.tickets.filter(t => !S.tags[t.id]).length;
  const fichesEnAttente = () => S.fiches.filter(f => f.statut === 'attente');
  const candidat    = () => S.tickets.find(t => !S.tags[t.id]) || null;
  const parId       = id => S.tickets.find(t => t.id === id) || S.extras.find(t => t.id === id) || null;
  const numeroTicket = t => String(t.ref || '').replace(/^#/, '');
  const articlesTicket = t => (t.articles || []).join(', ') || 'Article non détaillé';

  const ICONES_VUE = {
    comptoir:'<path d="M6 3h12l1.5 5H4.5z"/><path d="M5 8v12h14V8"/><path d="M9.5 12.5h5"/>',
    clients:'<circle cx="9" cy="8.5" r="3.3"/><path d="M3.5 20v-1.2A4.3 4.3 0 0 1 7.8 14.5h2.4a4.3 4.3 0 0 1 4.3 4.3V20"/><path d="M16.5 6.2a3.3 3.3 0 0 1 0 6.1M17.5 14.6h.8a4.3 4.3 0 0 1 4.2 4.3V20"/>',
    diag:'<circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M8 10.5h5M10.5 8v5"/>',
    tableau:'<rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/>'
  };

  function rendreNav(){
    const n = enAttente() + fichesEnAttente().length;
    const items = [
      {id:'comptoir', lib:'Comptoir', pastille:true},
      {id:'clients',  lib:'Clientes'},
      {id:'diag',     lib:'Diagnostic complet'},
      {id:'tableau',  lib:'Tableau de bord'}
    ];
    document.getElementById('cptNav').innerHTML = items.map(i => `
      <button data-a="go:${i.id}" ${S.vue===i.id?'aria-current="page"':''}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">${ICONES_VUE[i.id]}</svg>
        <span class="lib">${i.lib}</span>
        ${i.pastille && n ? `<span class="pastille">${n}</span>` : ''}
      </button>`).join('');
    const z1 = document.getElementById('cptZn'), z2 = document.getElementById('cptZn2');
    if(z1) z1.textContent = enAttente();
    if(z2) z2.textContent = enAttente();
  }

  /* ── vue : le comptoir ─────────────────────────────────────────────── */

  function ligneTicket(t){
    const pose = S.tags[t.id];
    const note = S.notes[t.id];
    const ouverte = S.noteOuverte === t.id;
    return `<div class="tk ${pose?'tk--fait':''}">
      <div class="ref"><b>${esc(t.ref)}</b><span>${ilYA(t.heure)}</span></div>
      <div class="det"><b>${esc(articlesTicket(t))}</b><span class="tnum">${euros(t.montant, t.devise)}</span><i>${esc(t.paiement)}</i></div>
      <div class="act">
        ${pose ? `
          <span class="fait">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 12.5l5 5L20 6.5"/></svg>
            ${esc(pose)}
          </span>
          <button class="bq" data-a="detag:${t.id}">Modifier</button>`
        : `
          <button class="bq" data-a="tag:${t.id}:Nouvelle cliente">Nouvelle cliente</button>
          <button class="bq" data-a="tag:${t.id}:Cliente récurrente">Cliente récurrente</button>`}
        <button class="bq bq--fiche" data-a="exp:${t.id}">Créer la fiche</button>
        <button class="bi" data-a="note:${t.id}" title="Note interne" aria-label="Note interne">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B7050" stroke-width="1.7" stroke-linecap="round">
            <path d="M5 4h9l5 5v11H5z"/><path d="M14 4v5h5"/><path d="M8 13h7M8 16.5h5"/></svg>
        </button>
      </div>
      ${ouverte ? `<div class="note-z">
          <textarea data-note="${t.id}" placeholder="Ce qu'elle a dit, ce qu'elle cherchait, ce qu'il faudra lui demander la prochaine fois…">${esc(note||'')}</textarea>
          <div class="p"><small>Reste sur cette tablette. N'est envoyée ni à Shopify ni à Klaviyo.</small>
            <button class="bq" data-a="noteoff">Fermer</button></div>
        </div>` : (note ? `<div class="note-vue">${esc(note)}</div>` : '')}
    </div>`;
  }

  /* Un ticket de la veille, ou d'il y a trois jours, n'est plus dans la liste
     courte. On le retrouve par son numéro : le serveur remonte alors plus loin. */
  function champNumeroTicket(ou){
    const tk = ou === 'exp' ? parId(S.exp.ticket) : parId(S.ticketVente);
    const vieux = tk && !S.tickets.some(t => t.id === tk.id);
    return `
      <div class="st" style="margin:16px 0 8px">Son ticket n'est plus dans la liste ?</div>
      <div style="display:flex;gap:8px;align-items:flex-end;flex-wrap:wrap">
        <label class="ch" style="flex:1;min-width:150px"><span>Numéro du ticket</span>
          <input data-num="1" value="${esc(S.numTicket)}" inputmode="numeric" autocomplete="off" placeholder="1481"></label>
        <button class="bq" style="height:48px" data-a="chticket:${ou}">${S.numEtat === 'charge' ? 'Recherche…' : 'Chercher'}</button>
      </div>
      ${S.numEtat === 'absent' ? `<div class="recap">${esc(S.numMsg)}</div>` : ''}
      ${vieux ? `<div class="recap">Ticket ${esc(tk.ref)} du ${dateCourte(tk.heure)} · ${euros(tk.montant, tk.devise)} · ${esc(articlesTicket(tk))}</div>` : ''}`;
  }

  function bandeauRapprochement(){
    const attente = fichesEnAttente();
    if(!attente.length) return '';
    return `
    <div class="zet zet--rap">
      <div class="zet-tete zet-tete--rap">
        <span class="point" style="background:var(--vert)"></span>
        <div><b>Rapprochements à confirmer</b>
          <div class="d">Ces fiches ont été créées avant le paiement. Un ticket vient d'arriver : est-ce le bon ?</div></div>
        <span class="n" style="color:var(--vert)">${attente.length} en attente</span>
      </div>
      ${attente.map(f => {
        const c = candidat();
        return `<div class="rap">
          <div class="rap-f">
            <div class="ini">${esc(initiales(f.prenom + ' ' + (f.nom||'')))}</div>
            <div><b>${esc(f.prenom)} ${esc(f.nom||'')}</b>
              <span>Fiche créée ${ilYA(f.quand)} · en attente de son ticket</span></div>
          </div>
          ${c ? `
            <div class="rap-t">
              <div class="rap-t-h"><b>${esc(c.ref)}</b><span class="tnum">${euros(c.montant, c.devise)}</span><i>${ilYA(c.heure)}</i></div>
              <div class="rap-t-a">${esc(articlesTicket(c))} · ${esc(c.paiement)}</div>
            </div>
            <div class="rap-b">
              <button class="b-vert" style="height:38px;padding:0 15px" data-a="rapok:${f.id}:${c.id}">C'est elle</button>
              <button class="bq" data-a="rapnon:${f.id}">Un autre ticket</button>
              <button class="bq" data-a="rapsans:${f.id}">Elle n'a rien acheté</button>
            </div>`
          : `<div class="rap-vide">Aucun ticket en attente. Sa fiche reste ouverte jusqu'à ce qu'un ticket arrive.</div>`}
        </div>`;
      }).join('')}
    </div>`;
  }

  function vueComptoir(){
    const n = enAttente();
    const f = fichesEnAttente().length;
    let corpsTickets;
    if((S.ticketsEtat === 'charge' || S.ticketsEtat === 'inconnu') && !S.tickets.length){
      corpsTickets = `<div class="vide" style="padding:26px 20px">Lecture de la caisse Zettle…</div>`;
    } else if(S.ticketsEtat === 'absent'){
      corpsTickets = `<div class="vide" style="padding:26px 20px">${esc(S.ticketsMsg)}</div>`;
    } else if(S.ticketsEtat === 'erreur'){
      corpsTickets = `<div class="vide" style="padding:26px 20px">La caisse n'a pas répondu : ${esc(S.ticketsMsg)}
        <br><button class="bq" style="margin-top:12px" data-a="rtickets">Réessayer</button></div>`;
    } else if(!S.tickets.length){
      corpsTickets = `<div class="vide" style="padding:26px 20px">Aucun ticket depuis hier matin.</div>`;
    } else {
      corpsTickets = S.tickets.map(ligneTicket).join('');
    }

    return `
    <div class="entete">
      <div><h1>Comptoir</h1>
        <div class="sous">Ce qui se passe maintenant, en boutique.</div></div>
    </div>

    <div class="gestes">
      <button class="geste geste--fort" data-a="exp:">
        <span class="g-ico">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">
            <path d="M4 20v-1.5A4.5 4.5 0 0 1 8.5 14h4a4.5 4.5 0 0 1 4.5 4.5V20"/><circle cx="10.5" cy="8" r="3.6"/><path d="M18.5 6.5v5M21 9h-5"/></svg>
        </span>
        <span class="g-t"><b>Enregistrer une cliente</b>
          <span>Elle est devant vous. Prénom, email, une question. 20 secondes.</span></span>
      </button>
      <button class="geste" data-a="go:diag">
        <span class="g-ico">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">
            <circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M8 10.5h5M10.5 8v5"/></svg>
        </span>
        <span class="g-t"><b>Diagnostic complet</b>
          <span>Les neuf questions, quand elle a le temps. Cinq minutes.</span></span>
      </button>
    </div>

    ${bandeauRapprochement()}

    <div class="zet">
      <div class="zet-tete">
        <span class="point"></span>
        <div><b>Tickets de caisse à identifier</b>
          <div class="d">Zettle ne transmet ni nom ni email. Dites seulement qui a payé, ou créez la fiche.</div></div>
        <span class="n">${S.ticketsEtat !== 'pret' ? '' : (n ? n + ' en attente' : 'Tout est identifié')}</span>
        <button class="bi" data-a="rtickets" title="Relire la caisse" aria-label="Relire la caisse" style="margin-left:10px">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6B7050" stroke-width="1.8" stroke-linecap="round">
            <path d="M20 11a8 8 0 1 0-2.3 5.7"/><path d="M20 5v6h-6"/></svg>
        </button>
      </div>
      ${corpsTickets}
    </div>

    ${(S.ticketsEtat === 'pret' && !n && !f) ? '<div class="calme">Rien à traiter. Le comptoir est à jour.</div>' : ''}`;
  }

  /* ── vue : les clientes ────────────────────────────────────────────── */

  const FILTRES = [
    {id:'tous',        lib:'Toutes'},
    {id:'recurrentes', lib:'Deux commandes ou plus'},
    {id:'une',         lib:'Une seule commande'},
    {id:'sansachat',   lib:'Jamais commandé'}
  ];

  function clientesFiltrees(){
    const q = pli(S.rech.trim());
    let liste = S.base;
    if(q) liste = liste.filter(c => c._r.indexOf(q) > -1);
    switch(S.filtre){
      case 'recurrentes': liste = liste.filter(c => (c.commandes||0) >= 2); break;
      case 'une':         liste = liste.filter(c => (c.commandes||0) === 1); break;
      case 'sansachat':   liste = liste.filter(c => !(c.commandes||0)); break;
    }
    return liste;
  }

  function vueClientes(){
    if(S.baseEtat === 'charge' || S.baseEtat === 'inconnu'){
      return `<div class="entete"><div><h1>Clientes</h1>
        <div class="sous">Chargement de la base depuis Shopify…</div></div></div>
        <div class="tbl-w"><div class="vide">Cela prend quelques secondes la première fois. Ensuite, tout est instantané.</div></div>`;
    }
    if(S.baseEtat === 'erreur'){
      return `<div class="entete"><div><h1>Clientes</h1></div></div>
        <div class="tbl-w"><div class="vide">La base n'a pas pu être chargée.
          <br><button class="bq" style="margin-top:12px" data-a="rbase">Réessayer</button></div></div>`;
    }
    const toutes = clientesFiltrees();
    const liste = toutes.slice(0, 200);
    return `
    <div class="entete">
      <div><h1>Clientes</h1>
        <div class="sous">${S.base.length} fiches dans Shopify · index repris ${ilYA(S.baseQuand)}</div></div>
      <div style="display:flex;gap:8px;flex-wrap:wrap">
        <button class="b-clair" data-a="rbase">Reprendre la base</button>
        <button class="b-vert" data-a="exp:">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>
          Enregistrer une cliente
        </button>
      </div>
    </div>

    <div class="filtres">
      ${FILTRES.map(x => `<button data-a="fil:${x.id}" aria-pressed="${S.filtre===x.id}">${x.lib}</button>`).join('')}
    </div>

    <div class="tbl-w">
      ${liste.length === 0 ? `<div class="vide">Aucune cliente ne correspond.</div>` : `
      <table class="cl">
        <thead><tr>
          <th>Cliente</th><th>Email</th><th>Téléphone</th>
          <th style="text-align:right">Commandes en ligne</th><th></th>
        </tr></thead>
        <tbody>
          ${liste.map(c => `<tr class="cl-row" data-a="ouvrir:${esc(c.id)}" data-nom="${esc(c.nom || '')}" tabindex="0">
            <td><div class="qui">
              <div class="ini">${esc(initiales(c.nom))}</div>
              <div><b>${esc(c.nom || 'Sans nom')}</b><span>${(c.commandes||0) ? 'cliente' : 'aucune commande en ligne'}</span></div>
            </div></td>
            <td>${esc(c.email || '—')}</td>
            <td class="tnum">${esc(c.telephone || '—')}</td>
            <td class="tnum" style="text-align:right;font-weight:600">${c.commandes||0}</td>
            <td class="chev"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 5l7 7-7 7"/></svg></td>
          </tr>`).join('')}
        </tbody>
      </table>`}
    </div>
    ${toutes.length > liste.length ? `<div class="pile" style="padding-left:4px">${toutes.length} fiches correspondent. Les 200 premières sont affichées : affinez la recherche pour voir les suivantes.</div>` : ''}`;
  }

  /* ── vue : la fiche d'une cliente ──────────────────────────────────── */

  /* La fréquence de lavage a été enregistrée soit par le diagnostic (clés
     courtes), soit par l'ancien comptoir (clés longues), soit en toutes lettres.
     On accepte les trois plutôt que d'afficher « non calculée » à tort. */
  const LAVAGE_LIBELLE = {
    jour:'Tous les jours', j2:'Tous les 2 jours', j3:'Tous les 3 jours',
    sem:'Une fois par semaine', moins:"Moins d'une fois par semaine",
    quotidien:'Tous les jours', '2_3_semaine':'Tous les 2 jours',
    '1_semaine':'Une fois par semaine'
  };
  function relanceDepuis(valeur){
    if(!valeur) return null;
    if(RELANCES_Q2[valeur]) return RELANCES_Q2[valeur];
    const lib = LAVAGE_LIBELLE[valeur] || valeur;
    return RELANCES[lib] || null;
  }

  function formulaireCorrection(c){
    const C = S.correction;
    return `
    <div class="bloc" style="margin-bottom:16px">
      <div class="bloc-tete"><div><h2>Corriger sa fiche</h2>
        <div class="st">Seuls les champs modifiés sont envoyés à Shopify.</div></div>
        <button class="bq" data-a="corrannuler">Annuler</button></div>
      <div class="champs">
        <label class="ch"><span>Prénom</span><input data-corr="prenom" value="${esc(C.prenom)}" autocomplete="off"></label>
        <label class="ch"><span>Nom</span><input data-corr="nom" value="${esc(C.nom)}" autocomplete="off"></label>
      </div>
      <label class="ch" style="margin-top:12px"><span>Adresse email</span>
        <input data-corr="email" type="email" value="${esc(C.email)}" inputmode="email" autocomplete="off"></label>
      <button class="b-vert b-large" ${S.occupe?'disabled':''} data-a="corrgo">Enregistrer la correction</button>
    </div>`;
  }

  function vueFiche(){
    if(S.ficheEtat === 'erreur'){
      return `<div class="entete"><div>
        <button class="lien" data-a="go:clients" style="margin-bottom:8px;display:block">Retour aux clientes</button>
        <h1>${esc(S.fiche && S.fiche.nom || 'Fiche')}</h1></div></div>
        <div class="bloc"><div class="vide">La fiche n'a pas pu être ouverte : ${esc(S.ficheErr)}</div></div>`;
    }
    if(S.ficheEtat !== 'pret' || !S.ficheData){
      return `<div class="entete"><div>
        <button class="lien" data-a="go:clients" style="margin-bottom:8px;display:block">Retour aux clientes</button>
        <h1>${esc(S.fiche && S.fiche.nom || 'Fiche')}</h1>
        <div class="sous">Ouverture de sa fiche…</div></div></div>
        <div class="bloc"><div class="vide">Shopify remonte ses commandes et son diagnostic.</div></div>`;
    }

    const c = S.ficheData.cliente || {};
    const achats = S.ficheData.achats || [];
    const p = c.profil || {};
    const enLigne = Number(c.depense || 0);
    const boutique = Number(p.total_boutique || 0);
    const passages = Number(p.nb_passages || 0);
    const relance = relanceDepuis(p.frequence_lavage);
    const dernier = achats.length ? achats[0].date : (p.dernier_passage || null);
    const jDernier = dernier ? jours(dernier) : null;
    const jRelance = relance ? parseInt(String(relance).replace('J+',''), 10) : null;
    const retard = (jDernier !== null && jRelance !== null) ? jDernier - jRelance : null;
    const enRetard = retard !== null && retard > 0;
    const noteCle = 'fiche-' + (c.id || '');

    return `
    <div class="entete" style="margin-bottom:20px">
      <div>
        <button class="lien" data-a="go:clients" style="margin-bottom:8px;display:block">Retour aux clientes</button>
        <h1>${esc(c.nom || 'Sans nom')}</h1>
        <div class="sous">${esc(c.email || "pas d'email")}${c.depuis ? ' · cliente depuis le ' + dateCourte(c.depuis) : ''}</div>
      </div>
      <div style="display:flex;gap:8px;flex-wrap:wrap">
        <button class="b-clair" data-a="corriger">Corriger sa fiche</button>
        <button class="b-clair" data-a="diagpour">Nouveau diagnostic</button>
        <button class="b-vert" data-a="exppour">Enregistrer un passage</button>
      </div>
    </div>

    ${S.correction ? formulaireCorrection(c) : ''}

    <div class="kpis" style="margin-bottom:18px">
      <div class="kpi"><div class="lab">Valeur totale</div>
        <div class="val tnum">${euros(enLigne + boutique, c.devise)}</div>
        <div class="note">${euros(enLigne, c.devise)} en ligne · ${boutique ? euros(boutique, c.devise) : '0 €'} en boutique</div></div>
      <div class="kpi"><div class="lab">Commandes en ligne</div>
        <div class="val tnum">${c.commandes || 0}</div>
        <div class="note">${(c.commandes||0) ? 'panier moyen ' + euros(enLigne / c.commandes, c.devise) : 'aucune commande'}</div></div>
      <div class="kpi"><div class="lab">Passages au comptoir</div>
        <div class="val tnum">${passages}</div>
        <div class="note">${p.dernier_passage ? 'dernier le ' + dateCourte(p.dernier_passage) : 'jamais enregistrée en boutique'}</div></div>
      <div class="kpi ${enRetard ? 'kpi--focus' : ''}"><div class="lab">Réachat attendu</div>
        <div class="val tnum">${relance || 'non calculé'}</div>
        <div class="note">${!relance ? 'fréquence de lavage inconnue'
          : jDernier === null ? 'pas encore de premier achat'
          : enRetard ? retard + ' jours de retard' : 'dans les temps'}</div></div>
    </div>

    <div class="grille">
      <div class="bloc">
        <div class="bloc-tete"><div><h2>Ses commandes en ligne</h2>
          <div class="st">${achats.length ? achats.length + ' commande(s) remontée(s) de Shopify' : 'Aucune commande en ligne'}</div></div></div>
        ${!achats.length ? `<div class="vide" style="padding:22px 0">Rien en ligne.
          ${passages ? "Elle achète en boutique : c'est le comptoir qui tient son historique." : "C'est exactement la cliente à relancer."}</div>` : `
        <div class="hist">
          ${achats.map(o => `<div class="hl">
            <div class="hl-d"><b>${esc(o.numero || '')}</b><span>${dateCourte(o.date)}</span></div>
            <div class="hl-a">${esc((o.articles||[]).join(', ') || '—')}</div>
            <div class="hl-c"><span class="canal">En ligne</span></div>
            <div class="hl-t tnum">${euros(o.montant, o.devise)}</div>
          </div>`).join('')}
        </div>`}
      </div>

      <div style="display:flex;flex-direction:column;gap:16px">
        <div class="bloc">
          <div class="bloc-tete"><div><h2>Son diagnostic</h2>
            <div class="st">${p.profil_code ? 'Ce qui est au dossier dans Shopify.' : 'Rien au dossier.'}</div></div></div>
          ${!p.profil_code ? `<div class="vide" style="padding:18px 0">Aucun diagnostic enregistré.
            Proposez-le-lui à sa prochaine visite.</div>` : `
          <div class="timeline">
            <div class="tl">
              <div class="tl-code">${esc(p.profil_code)}</div>
              <div class="tl-t"><b>${esc(p.cuir_chevelu || 'Profil au dossier')}</b>
                <span>${p.formule_recommandee ? 'formule ' + esc(p.formule_recommandee) : 'formule non renseignée'}</span></div>
              <span class="tl-now">actuel</span>
            </div>
          </div>
          ${p.frequence_lavage ? `<div class="pile">Lavage : ${esc(LAVAGE_LIBELLE[p.frequence_lavage] || p.frequence_lavage)}.
            ${relance ? 'Relance de réachat calculée à ' + relance + '.' : ''}</div>` : ''}`}
        </div>

        ${c.etiquettes && c.etiquettes.length ? `<div class="bloc">
          <div class="bloc-tete"><div><h2>Ses étiquettes</h2>
            <div class="st">Ce sont elles que Klaviyo écoute.</div></div></div>
          <div class="code">${c.etiquettes.slice(0,14).map(t => `<span>${esc(t)}</span>`).join('')}</div>
        </div>` : ''}

        ${c.note ? `<div class="bloc">
          <div class="bloc-tete"><div><h2>Ce qui est noté dans Shopify</h2>
            <div class="st">Empilé à chaque passage, jamais effacé.</div></div></div>
          <div class="hist">${String(c.note).split(/\n{2,}/).filter(x => x.trim()).slice(0,8)
            .map(x => `<div class="rap-vide" style="padding:10px 0">${esc(x.trim())}</div>`).join('')}</div>
        </div>` : ''}

        <div class="bloc">
          <div class="bloc-tete"><div><h2>Note de tablette</h2>
            <div class="st">Reste ici. Ne part ni dans Shopify ni dans Klaviyo.</div></div></div>
          <div class="note-z" style="margin:0">
            <textarea data-note="${esc(noteCle)}" placeholder="Ce qu'elle a dit, ce qu'il faudra lui demander la prochaine fois…">${esc(S.notes[noteCle]||'')}</textarea>
          </div>
        </div>
      </div>
    </div>`;
  }

  /* ── vue : le tableau de bord ──────────────────────────────────────── */
  /* On n'affiche que ce qui est réellement mesuré : la caisse d'aujourd'hui
     et la forme de la base. Le reste viendra quand la source existera. */

  function vueTableau(){
    const auj = new Date(); auj.setHours(0,0,0,0);
    const duJour = S.tickets.filter(t => new Date(t.heure).getTime() >= auj.getTime());
    const ca = duJour.reduce((s,t) => s + Number(t.montant||0), 0);
    const panier = duJour.length ? ca / duJour.length : 0;
    const especes = duJour.filter(t => /esp/i.test(t.paiement||'')).length;
    const identifies = duJour.filter(t => S.tags[t.id]).length;

    const base = S.base || [];
    const avec = base.filter(c => (c.commandes||0) > 0).length;
    const recurrentes = base.filter(c => (c.commandes||0) >= 2).length;
    const reachat = avec ? Math.round(recurrentes / avec * 100) : null;
    const sansAchat = base.length - avec;

    return `
    <div class="entete">
      <div><h1>Tableau de bord</h1>
        <div class="sous">Ce qui est mesuré, et rien d'autre. Deux sources : la caisse Zettle et la base Shopify.</div></div>
      <button class="b-clair" data-a="rtickets">Actualiser</button>
    </div>

    <div class="bloc-tete" style="margin-bottom:12px"><div><h2>La caisse aujourd'hui</h2>
      <div class="st">Tickets Zettle depuis minuit${S.ticketsQuand ? ' · relu ' + ilYA(S.ticketsQuand) : ''}.</div></div></div>
    <div class="kpis" style="margin-bottom:26px">
      <div class="kpi kpi--focus"><div class="lab">Encaissé</div>
        <div class="val tnum">${euros(ca)}</div><div class="note">${duJour.length} ticket(s)</div></div>
      <div class="kpi"><div class="lab">Panier moyen</div>
        <div class="val tnum">${duJour.length ? euros(panier) : '—'}</div>
        <div class="note">objectif de la maison : 45 à 60 €</div></div>
      <div class="kpi"><div class="lab">Tickets identifiés</div>
        <div class="val tnum">${identifies} / ${duJour.length}</div>
        <div class="note">${duJour.length && identifies === duJour.length ? 'tout est rattaché' : 'à qualifier au comptoir'}</div></div>
      <div class="kpi"><div class="lab">Payés en espèces</div>
        <div class="val tnum">${especes}</div>
        <div class="note">${duJour.length - especes} par carte</div></div>
    </div>

    <div class="bloc-tete" style="margin-bottom:12px"><div><h2>La base clientes</h2>
      <div class="st">${S.baseEtat === 'pret' ? 'Index Shopify repris ' + ilYA(S.baseQuand) + '.' : 'Base non chargée.'}</div></div></div>
    <div class="kpis" style="margin-bottom:20px">
      <div class="kpi"><div class="lab">Fiches</div>
        <div class="val tnum">${base.length}</div><div class="note">dans Shopify</div></div>
      <div class="kpi"><div class="lab">Ont déjà commandé en ligne</div>
        <div class="val tnum">${avec}</div>
        <div class="note">${base.length ? Math.round(avec/base.length*100) + ' % de la base' : ''}</div></div>
      <div class="kpi"><div class="lab">Deux commandes ou plus</div>
        <div class="val tnum">${reachat === null ? '—' : reachat + ' %'}</div>
        <div class="note">objectif de la maison : 55 à 60 %</div></div>
      <div class="kpi"><div class="lab">Jamais commandé en ligne</div>
        <div class="val tnum">${sansAchat}</div>
        <div class="note">clientes boutique, ou à réveiller</div></div>
    </div>

    <div class="bloc">
      <div class="bloc-tete"><div><h2>Ce que ce tableau ne dit pas encore</h2>
        <div class="st">Autant le nommer que le faire croire.</div></div></div>
      <div class="pile" style="border-top:0;padding-top:0">
        Le réachat affiché ne compte que les commandes en ligne : Shopify ignore les ventes Zettle,
        qui ne remontent pas dans les commandes. Le chiffre boutique n'existe donc que sur les fiches
        où un passage a été enregistré ici. Plus le comptoir est tenu, plus ce tableau devient vrai.
      </div>
    </div>`;
  }
function ordonnance(){
  const d = S.d, R = prescription(), C = S.coord;
  const soins = R.second ? [{s:SOINS[R.principal], r:'Étape 1 : assainir'}, {s:SOINS[R.second], r:'Étape 2 : renforcer'}]
                         : [{s:SOINS[R.principal], r:'Pour le cuir chevelu'}];
  const relance = d.Q2 ? RELANCES_Q2[d.Q2] : null;
  const tk = parId(S.ticketVente);
  const libres = S.tickets.filter(t => !S.tags[t.id]);
  const pret = emailOk(C.email) && C.prenom.trim() && C.consent && S.vente && !S.occupe
               && !(S.vente === 'paye' && !tk);
  const recap = S.vente === 'paye'   ? (tk ? `Achat comptoir ${euros(tk.montant, tk.devise)}, ticket ${tk.ref} rapproché.`
                                            : 'Choisissez son ticket dans la liste.')
    : S.vente === 'apayer' ? "La fiche part sans achat. Son ticket vous sera proposé dans les rapprochements dès qu'il arrive."
    : S.vente === 'non'    ? "Aucun achat. Segment « diagnostic fait, jamais acheté »."
    : "Indiquez où en est le paiement.";

  return `
  <div class="entete" style="margin-bottom:18px">
    <div><h1>Ordonnance</h1><div class="sous">${d.flow.length} questions posées, adaptées à ce qu'elle a décrit · profil ${R.profil.code}</div></div>
    <button class="b-clair" data-a="recommencer">Recommencer</button>
  </div>

  ${R.alerte ? `<div class="alerte">
    <b>Avis médical recommandé.</b> Une chute brutale ou par plaques rondes peut révéler une cause médicale.
    Orientez-la vers un dermatologue ou un trichologue, en complément de la routine, jamais à la place.</div>` : ''}

  <div class="ord">
    <div style="display:flex;flex-direction:column;gap:16px">
      <div class="bloc">
        <div class="profil">
          <div class="profil-code">${R.profil.code}</div>
          <div class="profil-t">
            <div class="formule">${R.profil.titre}</div>
            <div class="profil-attrs">
              <div><b>Cuir chevelu</b><span>${R.profil.cc}</span></div>
              <div><b>Sébum</b><span>${R.profil.sb}</span></div>
              <div><b>Fibre</b><span>${R.profil.fb}</span></div>
            </div>
          </div>
        </div>
        <div class="soins">
          ${soins.map(x => `<div class="soin"><span class="soin-r">${x.r}</span>
            <b>${x.s.nom}</b><i>${x.s.sub}</i><span class="soin-d">${x.s.desc}</span></div>`).join('')}
          <div class="soin"><span class="soin-r">Pour les longueurs</span>
            <b>${SOINS.apres.nom}</b><i>${SOINS.apres.sub}</i><span class="soin-d">${SOINS.apres.desc}</span></div>
        </div>
        <div class="props">
          <div><b>Profil Code</b><span>${R.profil.code}</span></div>
          ${d.priorite ? `<div><b>Priorité choisie</b><span>${ETIQ[d.priorite]}</span></div>` : ''}
          <div><b>Diagnostic Validated</b><span>${R.valides.join(', ')}</span></div>
          <div><b>lavage_frequence</b><span>${d.Q2 ? Q.Q2.ops.find(o=>o[0]===d.Q2)[1] : 'non renseigné'}</span></div>
          <div><b>lieu_diagnostic</b><span>Maison-Atelier Paris</span></div>
          <div><b>Relance de réachat</b><span style="color:var(--terra);font-weight:600">${relance || 'non calculée'}</span></div>
        </div>
      </div>

      <div class="bloc">
        <div class="bloc-tete"><div><h2>Ses réponses</h2>
          <div class="st">Corrigez sans tout reprendre.</div></div></div>
        ${d.flow.map((cle,i) => {
          const q = Q[cle];
          let v;
          if(q.type === 'multi'){
            const arr = q.cat ? (d[q.cat][q.k]||[]) : d[q.k];
            v = arr.map(x => q.ops.find(o => o[0] === x)[1]).join(', ');
          } else {
            const brut = q.cat ? d[q.cat][q.k] : d[q.sk];
            const o = q.ops.find(o => o[0] === brut);
            v = o ? o[1] : '';
          }
          return `<div class="rep-l"><b>${q.t.replace(/\s*\?$/,'')}</b>
            <span>${v || '<span style="color:var(--sauge-c)">non renseigné</span>'}</span>
            <button data-a="revenir:${i}">Modifier</button></div>`;
        }).join('')}
      </div>
    </div>

    <div style="display:flex;flex-direction:column;gap:16px">
      <div class="bloc">
        <div class="bloc-tete"><div><h2>Ses coordonnées</h2>
          <div class="st">Demandées à la fin, comme en ligne.</div></div></div>
        <div class="champs">
          <label class="ch"><span>Prénom</span>
            <input data-coord="prenom" value="${esc(C.prenom)}" placeholder="Marion" autocomplete="off"></label>
          <label class="ch"><span>Nom <i>facultatif</i></span>
            <input data-coord="nom" value="${esc(C.nom)}" placeholder="Lefèvre" autocomplete="off"></label>
        </div>
        <label class="ch" style="margin-top:12px"><span>Adresse email</span>
          <input data-coord="email" type="email" value="${esc(C.email)}" placeholder="marion@exemple.fr" inputmode="email" autocomplete="off"></label>
        <button class="consent" data-a="consentd" aria-pressed="${C.consent}">
          <span class="case">${C.consent?'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F1F0E4" stroke-width="3.4" stroke-linecap="round"><path d="M4 12.5l5 5L20 6.5"/></svg>':''}</span>
          <span>Elle accepte de recevoir son ordonnance et nos emails. À cocher devant elle.</span>
        </button>
      </div>

      <div class="bloc">
        <div class="bloc-tete"><div><h2>Note d'atelier</h2>
          <div class="st">Reste sur la tablette.</div></div></div>
        <div class="note-z" style="margin:0">
          <textarea data-note="diag" placeholder="Ce que vous avez vu, ce qu'elle a dit…">${esc(S.notes.diag||'')}</textarea>
        </div>
      </div>

      <div class="bloc">
        <div class="bloc-tete"><div><h2>Où en est le paiement ?</h2>
          <div class="st">Le diagnostic se fait avant la caisse : le ticket arrivera après.</div></div></div>
        <div class="tks">
          <button data-a="vente:apayer" aria-pressed="${S.vente==='apayer'}">
            <span class="rond"></span><b>Elle va payer maintenant</b></button>
          <button data-a="vente:paye" aria-pressed="${S.vente==='paye'}">
            <span class="rond"></span><b>Elle a déjà payé</b></button>
          <button data-a="vente:non" aria-pressed="${S.vente==='non'}">
            <span class="rond"></span><b>Pas d'achat aujourd'hui</b></button>
        </div>
        ${S.vente === 'paye' ? `
          <div class="st" style="margin:16px 0 10px">Quel ticket ?</div>
          ${libres.length ? `<div class="tks">
            ${libres.slice(0,4).map(t => `<button data-a="tkv:${t.id}" aria-pressed="${S.ticketVente===t.id}">
              <span class="rond"></span><b>${esc(t.ref)}</b><span style="color:var(--sauge-c)">${ilYA(t.heure)}</span><i class="tnum">${euros(t.montant, t.devise)}</i>
            </button>`).join('')}
          </div>` : '<div class="recap" style="margin-top:10px">Aucun ticket libre pour l\'instant.</div>'}
          ${champNumeroTicket('diag')}` : ''}
        <div class="code" style="margin-top:14px">
          <span>Fait en boutique</span>
          ${S.vente==='non' ? '<span>N\'a pas acheté</span>' : S.vente ? '<span>A acheté</span>' : ''}
          <span>${R.profil.code}</span>
        </div>
        <div class="recap">${recap}</div>
        <button class="b-vert b-large" ${pret?'':'disabled'} data-a="creer">${S.occupe ? 'Enregistrement…' : 'Créer la fiche cliente'}</button>
      </div>
    </div>
  </div>`;
}
function vueDiag(){
  const d = S.d;
  if(d.i >= d.flow.length) return ordonnance();
  const cle = d.flow[d.i], q = Q[cle];
  const pct = Math.round((d.i / d.flow.length) * 100);
  const sel = v => q.type === 'multi'
      ? (q.cat ? (d[q.cat][q.k]||[]) : d[q.k]).includes(v)
      : (q.cat ? d[q.cat][q.k] : d[q.sk]) === v;

  return `
  <div class="diag">
    <div class="diag-tete">
      <div class="s">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F1F0E4" stroke-width="1.7" stroke-linecap="round">
          <circle cx="10.5" cy="10.5" r="6.5"/><path d="M15.5 15.5 21 21"/><path d="M8 10.5h5M10.5 8v5"/></svg>
      </div>
      <div><b>Diagnostic capillaire</b>
        <span>Le même qu'en ligne. Les questions s'adaptent à ce qu'elle décrit.</span></div>
      <button class="b-clair" style="margin-left:auto" data-a="go:comptoir">Quitter</button>
    </div>
    <div class="echappe">
      <span>Elle ne veut pas répondre aux questions ?</span>
      <button class="lien" data-a="exp:">Enregistrer sa fiche en 20 secondes</button>
    </div>
    <div class="progres"><span>${q.et} · question ${d.i+1}</span><span class="tnum">${pct} %</span></div>
    <div class="rail"><i style="width:${pct}%"></i></div>

    <div class="carte-q">
      ${q.alerte ? '<div class="alerte alerte--q">Question de sécurité. Si elle répond oui, la routine ne suffit pas.</div>' : ''}
      <h2>${q.t}</h2>
      ${q.sub ? `<div class="aide">${q.sub}</div>` : ''}
      <div class="ops">
        ${q.ops.map(o => `<button class="op" data-a="dr:${cle}:${o[0]}" aria-pressed="${sel(o[0])}">
          <span class="k">${q.type==='multi'
            ? (sel(o[0]) ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round"><path d="M4 12.5l5 5L20 6.5"/></svg>' : '')
            : ''}</span>${o[1]}</button>`).join('')}
      </div>
      <div class="pied-q">
        ${d.i > 0 ? '<button class="bq" data-a="dprec">Précédent</button>' : ''}
        ${q.type === 'multi'
          ? `<button class="b-vert" style="height:44px;padding:0 20px" ${repondu(cle)?'':'disabled'} data-a="dsuite">Continuer</button>`
          : '<span class="auto">Question suivante automatique</span>'}
      </div>
    </div>
  </div>`;
}
function vueExpress(){
  const E = S.exp;
  const tk = parId(E.ticket);
  const libres = S.tickets.filter(t => !S.tags[t.id]);
  const pret = emailOk(E.email) && E.prenom.trim() && E.consent && !S.occupe && !(E.mode === 'paye' && !tk);
  const relance = E.freq ? RELANCES[E.freq] : null;

  return `
  <div class="diag">
    <div class="diag-tete">
      <div class="s">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F1F0E4" stroke-width="1.7" stroke-linecap="round">
          <path d="M4 20v-1.5A4.5 4.5 0 0 1 8.5 14h4a4.5 4.5 0 0 1 4.5 4.5V20"/><circle cx="10.5" cy="8" r="3.6"/><path d="M18.5 6.5v5M21 9h-5"/></svg>
      </div>
      <div><b>Fiche cliente sans diagnostic</b>
        <span>Le strict nécessaire. Le diagnostic pourra se faire plus tard, en ligne.</span></div>
      <button class="b-clair" style="margin-left:auto" data-a="go:comptoir">Quitter</button>
    </div>

    <div class="ord">
      <div class="bloc">
        <div class="bloc-tete"><div><h2>Ses coordonnées</h2>
          <div class="st">Sans adresse, il n'y a pas de fiche. Le reste est facultatif.</div></div></div>

        <div class="champs">
          <label class="ch"><span>Prénom</span>
            <input data-exp="prenom" value="${esc(E.prenom)}" placeholder="Marion" autocomplete="off"></label>
          <label class="ch"><span>Nom <i>facultatif</i></span>
            <input data-exp="nom" value="${esc(E.nom)}" placeholder="Lefèvre" autocomplete="off"></label>
        </div>
        <label class="ch" style="margin-top:12px"><span>Adresse email</span>
          <input data-exp="email" type="email" value="${esc(E.email)}" placeholder="marion@exemple.fr" autocomplete="off" inputmode="email"></label>

        <div class="bloc-tete" style="margin:26px 0 12px"><div><h2>Une seule question</h2>
          <div class="st">C'est elle qui calcule la date de relance. Les huit autres peuvent attendre.</div></div></div>
        <div class="st" style="margin-bottom:10px;color:var(--encre)">Combien de fois lavez-vous vos cheveux par semaine ?</div>
        <div class="freqs">
          ${['Tous les jours','Tous les 2 jours','Tous les 3 jours','Une fois par semaine',"Moins d'une fois par semaine"].map(f =>
            `<button data-a="freq:${f}" aria-pressed="${E.freq===f}">${f}</button>`).join('')}
        </div>

        <button class="consent" data-a="consent" aria-pressed="${E.consent}">
          <span class="case">${E.consent?'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#F1F0E4" stroke-width="3.4" stroke-linecap="round"><path d="M4 12.5l5 5L20 6.5"/></svg>':''}</span>
          <span>Elle accepte de recevoir nos emails. À cocher devant elle, jamais à l'avance.</span>
        </button>
      </div>

      <div style="display:flex;flex-direction:column;gap:16px">
        <div class="bloc">
          <div class="bloc-tete"><div><h2>Où en est le paiement ?</h2>
            <div class="st">Neuf fois sur dix, vous la saisissez avant qu'elle paie.</div></div></div>
          <div class="tks">
            <button data-a="expmode:apayer" aria-pressed="${E.mode==='apayer'}">
              <span class="rond"></span><b>Elle va payer maintenant</b></button>
            <button data-a="expmode:paye" aria-pressed="${E.mode==='paye'}">
              <span class="rond"></span><b>Elle a déjà payé</b></button>
            <button data-a="expmode:aucun" aria-pressed="${E.mode==='aucun'}">
              <span class="rond"></span><b>Pas d'achat aujourd'hui</b></button>
          </div>
          ${E.mode === 'apayer' ? `<div class="recap" style="margin-top:14px">
            La fiche part sans achat. Dès que son ticket arrive sur le Zettle,
            il vous sera proposé dans « Rapprochements à confirmer ». Vous validez d'un geste.</div>` : ''}
          ${E.mode === 'paye' ? `
            <div class="st" style="margin:16px 0 10px">Quel ticket ? Le plus récent est en haut.</div>
            ${libres.length ? `<div class="tks">
              ${libres.slice(0,5).map(t => `<button data-a="exptk:${t.id}" aria-pressed="${E.ticket===t.id}">
                <span class="rond"></span><b>${esc(t.ref)}</b><span style="color:var(--sauge-c)">${ilYA(t.heure)}</span><i class="tnum">${euros(t.montant, t.devise)}</i>
              </button>`).join('')}
            </div>` : '<div class="recap">Aucun ticket libre pour l\'instant.</div>'}
            ${champNumeroTicket('exp')}` : ''}
        </div>

        <div class="bloc">
          <div class="bloc-tete"><div><h2>Ce qui sera enregistré</h2></div></div>
          <div class="code">
            <span>Boutique</span><span>Sans diagnostic</span>
            ${E.mode==='apayer' ? '<span style="border-color:var(--sauge);color:var(--sauge)">Ticket en attente</span>' : ''}
            ${relance ? `<span style="border-color:var(--terra);color:var(--terra)">Relance ${relance}</span>` : ''}
          </div>
          <div class="props">
            <div><b>Fiche Shopify</b><span>${E.prenom.trim() || '<span style="color:var(--sauge-c)">prénom manquant</span>'}${E.nom.trim()?' '+esc(E.nom):''}</span></div>
            <div><b>Email</b><span>${emailOk(E.email) ? esc(E.email) : '<span style="color:var(--sauge-c)">adresse manquante</span>'}</span></div>
            <div><b>lavage_frequence</b><span>${E.freq || '<span style="color:var(--sauge-c)">non renseigné</span>'}</span></div>
            <div><b>Achat du jour</b><span>${
              E.mode === 'paye'   ? (tk ? euros(tk.montant, tk.devise) + ' · ' + esc(tk.ref) : '<span style="color:var(--sauge-c)">ticket à choisir</span>')
            : E.mode === 'apayer' ? '<span style="color:var(--terra)">en attente de son ticket</span>'
            :                       '<span style="color:var(--sauge-c)">aucun</span>'}</span></div>
          </div>
          <div class="recap">Elle entrera dans le segment « Boutique, sans diagnostic ».
            Un email lui proposera le diagnostic en ligne, à son rythme.</div>
          <button class="b-vert b-large" id="bexp" ${pret?'':'disabled'} data-a="creerexp">${S.occupe ? 'Enregistrement…' : 'Créer la fiche cliente'}</button>
          <button class="lien" style="display:block;margin:12px auto 0" data-a="versdiag">Finalement, faire le diagnostic complet</button>
        </div>
      </div>
    </div>
  </div>`;
}


  /* ── la porte ──────────────────────────────────────────────────────── */
  function vuePorte(){
    return `
    <div class="diag" style="max-width:520px;margin:60px auto">
      <div class="carte-q">
        <h2>Le comptoir est verrouillé</h2>
        <div class="aide">Entrez le code du comptoir une seule fois. Il reste sur cette tablette
          et n'est demandé qu'ici. Aucune clé Shopify, Klaviyo ou Zettle ne descend jamais sur l'appareil.</div>
        <label class="ch" style="margin-top:24px"><span>Code du comptoir</span>
          <input id="cptCode" type="password" autocomplete="off" autocapitalize="off" spellcheck="false"></label>
        <button class="b-vert b-large" data-a="deverrouiller">Déverrouiller</button>
      </div>
    </div>`;
  }

  /* ── rendu ─────────────────────────────────────────────────────────── */
  const VUES = { comptoir:vueComptoir, clients:vueClientes, fiche:vueFiche,
                 diag:vueDiag, express:vueExpress, tableau:vueTableau };

  function rendre(){
    const page = document.getElementById('cptPage');
    if(!S.ouvert){
      racine.classList.add('cpt--ferme');
      page.innerHTML = vuePorte();
      const i = document.getElementById('cptCode'); if(i) i.focus();
      peindreMessage();
      return;
    }
    racine.classList.remove('cpt--ferme');
    rendreNav();
    page.innerHTML = (VUES[S.vue] || vueComptoir)();
    peindreMessage();
  }

  function peindreMessage(){
    const z = document.getElementById('cptMsg');
    if(!z) return;
    if(!S.message){ z.className = 'cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpt-msg on' + (S.message.ok ? ' ok' : S.message.ko ? ' ko' : '');
    z.textContent = S.message.t;
  }
  let effaceur = null;
  function dire(t, ok, ko){
    S.message = { t:t, ok:ok, ko:ko };
    peindreMessage();
    clearTimeout(effaceur);
    /* Une bonne nouvelle s'efface toute seule. Une mauvaise reste à l'écran. */
    if(ok) effaceur = setTimeout(() => { S.message = null; peindreMessage(); }, 8000);
  }

  /* ── le corps d'un enregistrement ──────────────────────────────────── */
  function corpsDepuisExpress(){
    const E = S.exp, tk = parId(E.ticket);
    const corps = {
      email: E.email.trim().toLowerCase(),
      prenom: E.prenom.trim(),
      nom: E.nom.trim(),
      id: S.pourId || null,
      parcours: E.mode === 'paye' ? "Elle a acheté" : "Elle est passée",
      ticket: '', montant: '',
      note: (S.notes.express || '').trim()
    };
    if(E.mode === 'paye' && tk){ corps.ticket = numeroTicket(tk); corps.montant = String(tk.montant); }
    if(E.freq) corps.observation = { lavage: E.freq };
    return corps;
  }

  function corpsDepuisDiagnostic(){
    const C = S.coord, R = prescription(), tk = parId(S.ticketVente);
    const corps = {
      email: C.email.trim().toLowerCase(),
      prenom: C.prenom.trim(),
      nom: C.nom.trim(),
      id: S.pourId || null,
      parcours: 'Diagnostic capillaire',
      ticket: '', montant: '',
      note: (S.notes.diag || '').trim(),
      observation: {
        profil: R.profil.code,
        formule: R.principal,
        cuir: R.profil.cc,
        lavage: S.d.Q2 || '',
        symptomes: S.d.checked.slice()
      }
    };
    if(S.vente === 'paye' && tk){ corps.ticket = numeroTicket(tk); corps.montant = String(tk.montant); }
    return corps;
  }

  function nouvelleFicheEnAttente(prenom, nom, email){
    S.fiches.push({ id:'f' + Date.now(), prenom:prenom || 'Nouvelle', nom:nom || '',
                    email:email || '', quand:Date.now(), statut:'attente', ticket:null });
    sauverLocal();
  }

  function remiseAZeroExpress(){
    S.exp = { prenom:'', nom:'', email:'', freq:null, consent:false, ticket:null, mode:'apayer' };
    delete S.notes.express; S.pourId = null;
    S.numTicket = ''; S.numEtat = ''; S.numMsg = '';
  }
  function remiseAZeroDiag(){
    S.d = dNeuf(); S.vente = null; S.ticketVente = null;
    S.coord = { prenom:'', nom:'', email:'', consent:false };
    delete S.notes.diag; S.pourId = null;
    S.numTicket = ''; S.numEtat = ''; S.numMsg = '';
  }

  /* ── interactions ──────────────────────────────────────────────────── */
  racine.addEventListener('click', e => {
    const b = e.target.closest('[data-a]');
    if(!b) return;
    const morceaux = b.dataset.a.split(':');
    const act = morceaux[0], a = morceaux[1], val = morceaux.slice(2).join(':');

    if(act === 'deverrouiller'){
      const i = document.getElementById('cptCode');
      const v = (i && i.value || '').trim();
      if(!v){ dire('Entrez le code du comptoir.', false, true); return; }
      try{ localStorage.setItem(CLE_CODE, v); }catch(err){}
      S.ouvert = true; S.message = null;
      demarrer();
      return;
    }
    if(act === 'verrouiller'){
      try{ localStorage.removeItem(CLE_CODE); }catch(err){}
      S.ouvert = false; S.base = []; S.baseEtat = 'inconnu';
      S.tickets = []; S.ticketsEtat = 'inconnu';
      rendre(); return;
    }

    else if(act === 'go'){
      S.vue = a; S.message = null;
      if(a === 'comptoir') chargerTickets(true);
      if(a === 'clients')  chargerBase(false);
      if(a === 'diag' && S.d.i === 0 && !S.d.checked.length) remiseAZeroDiag();
      haut();
    }
    else if(act === 'fil'){ S.filtre = a; }
    else if(act === 'ouvrir'){ ouvrirFiche([a].concat(morceaux.slice(2)).join(':'), b.dataset.nom || ''); return; }
    else if(act === 'rtickets'){ S.ticketsEtat = 'inconnu'; chargerTickets(false); return; }
    else if(act === 'rbase'){ S.baseEtat = 'inconnu'; chargerBase(true); dire('Reprise de la base…'); }

    else if(act === 'tag'){ S.tags[a] = val; S.noteOuverte = null; sauverLocal(); }
    else if(act === 'detag'){ delete S.tags[a]; sauverLocal(); }
    else if(act === 'note'){ S.noteOuverte = S.noteOuverte === a ? null : a; }
    else if(act === 'noteoff'){ S.noteOuverte = null; sauverLocal(); }

    /* ── le diagnostic ── */
    else if(act === 'dr'){
      const d = S.d, q = Q[a];
      if(q.type === 'multi'){
        const arr = q.cat ? (d[q.cat][q.k] = d[q.cat][q.k] || []) : d[q.k];
        const i = arr.indexOf(val);
        if(i > -1) arr.splice(i,1); else arr.push(val);
        rendre(); return;
      }
      if(q.cat) d[q.cat][q.k] = val; else d[q.sk] = val;
      if(a === 'Q4') construireFlow();
      if(a === 'C5' || a === 'D1') prolongerApres(a);
      clearTimeout(minuteur);
      rendre();
      minuteur = setTimeout(() => {
        if(S.d.i + 1 >= S.d.flow.length) poserArbitrage();
        S.d.i = Math.min(S.d.i + 1, S.d.flow.length);
        rendre();
      }, 280);
      return;
    }
    else if(act === 'dsuite'){
      if(S.d.flow[S.d.i] === 'multi') construireFlow();
      if(S.d.i + 1 >= S.d.flow.length) poserArbitrage();
      S.d.i = Math.min(S.d.i + 1, S.d.flow.length);
    }
    else if(act === 'dprec'){ S.d.i = Math.max(0, S.d.i - 1); }
    else if(act === 'revenir'){ S.d.i = +a; }
    else if(act === 'consentd'){ S.coord.consent = !S.coord.consent; }
    else if(act === 'recommencer'){ remiseAZeroDiag(); }
    else if(act === 'vente'){ S.vente = a; if(a === 'paye' && !S.ticketVente){ const c = candidat(); if(c) S.ticketVente = c.id; } }
    else if(act === 'tkv'){ S.ticketVente = a; }
    else if(act === 'chticket'){
      const num = String(S.numTicket || '').replace(/[^0-9]/g, '');
      if(!num){ dire('Entrez le numéro du ticket.', false, true); return; }
      const poser = t => { if(a === 'exp') S.exp.ticket = t.id; else S.ticketVente = t.id; };
      const deja = S.tickets.concat(S.extras).find(t => numeroTicket(t) === num);
      if(deja){ poser(deja); S.numEtat = 'trouve'; rendre(); return; }
      if(S.numEtat === 'charge') return;
      S.numEtat = 'charge'; S.numMsg = ''; rendre();
      /* On remonte quatre mois : au-delà, ce n'est plus un rattrapage de comptoir. */
      const debut = new Date(Date.now() - 120 * 86400000).toISOString().slice(0,10);
      api('tickets', { debut: debut, limite: 1000 })
        .then(d => {
          const t = (d.tickets || []).find(x => String(x.ref || '').replace(/^#/, '') === num);
          if(!t){ S.numEtat = 'absent'; S.numMsg = 'Aucun ticket ' + num + ' sur les 120 derniers jours.'; return; }
          const n = { id:t.id, ref:t.ref, heure:t.heure, montant:Number(t.montant || 0),
                      devise:t.devise || 'EUR', paiement:t.paiement || '', articles:t.articles || [] };
          if(!parId(n.id)) S.extras.push(n);
          poser(n); S.numEtat = 'trouve';
        })
        .catch(e => { S.numEtat = 'absent'; S.numMsg = e.message; })
        .then(() => rendre());
      return;
    }

    /* ── la fiche express ── */
    else if(act === 'exp'){
      S.vue = 'express';
      S.exp = { prenom:'', nom:'', email:'', freq:null, consent:false,
                ticket:a || null, mode: a ? 'paye' : 'apayer' };
      S.pourId = null; delete S.notes.express;
      haut();
    }
    else if(act === 'freq'){ S.exp.freq = S.exp.freq === [a].concat(morceaux.slice(2)).join(':') ? null : [a].concat(morceaux.slice(2)).join(':'); }
    else if(act === 'consent'){ S.exp.consent = !S.exp.consent; }
    else if(act === 'exptk'){ S.exp.ticket = a || null; }
    else if(act === 'expmode'){ S.exp.mode = a; if(a !== 'paye') S.exp.ticket = null;
                                else if(!S.exp.ticket){ const c = candidat(); if(c) S.exp.ticket = c.id; } }
    else if(act === 'versdiag'){ S.vue = 'diag'; remiseAZeroDiag(); haut(); }

    /* ── depuis une fiche existante ── */
    else if(act === 'exppour' || act === 'diagpour'){
      const c = (S.ficheData && S.ficheData.cliente) || {};
      const prenom = c.prenom || (c.nom || '').split(' ')[0] || '';
      const nom = (c.nom || '').replace(prenom, '').trim();
      S.pourId = c.id || null;
      if(act === 'exppour'){
        S.vue = 'express';
        S.exp = { prenom:prenom, nom:nom, email:c.email || '', freq:null, consent:false, ticket:null, mode:'apayer' };
      } else {
        S.vue = 'diag'; S.d = dNeuf(); S.vente = null; S.ticketVente = null;
        S.coord = { prenom:prenom, nom:nom, email:c.email || '', consent:false };
      }
      haut();
    }

    /* ── corriger une fiche ── */
    else if(act === 'corriger'){
      const c = (S.ficheData && S.ficheData.cliente) || {};
      const prenom = c.prenom || (c.nom || '').split(' ')[0] || '';
      S.correction = { prenom:prenom, nom:(c.nom || '').replace(prenom, '').trim(), email:c.email || '' };
    }
    else if(act === 'corrannuler'){ S.correction = null; }
    else if(act === 'corrgo'){
      const c = (S.ficheData && S.ficheData.cliente) || {};
      const C = S.correction;
      if(C.email.trim() && !emailOk(C.email)){ dire("Cette adresse email n'est pas valide.", false, true); return; }
      S.occupe = true; dire('Correction en cours…'); rendre();
      api('correction', { id:c.id, prenom:C.prenom, nom:C.nom, email:C.email })
        .then(() => { S.correction = null; dire('Fiche corrigée.', true); S.baseEtat = 'inconnu'; ouvrirFiche(c.id, C.prenom); })
        .catch(err => dire('Correction impossible : ' + err.message, false, true))
        .then(() => { S.occupe = false; rendre(); });
      return;
    }

    /* ── les rapprochements ── */
    else if(act === 'rapok'){
      const f = S.fiches.find(x => x.id === a);
      const t = parId(val);
      if(!f || !t) return;
      enregistrer({
        email: f.email, prenom: f.prenom, nom: f.nom, id: null,
        parcours: "Elle a acheté", ticket: numeroTicket(t), montant: String(t.montant), note: ''
      }, 'a bien acheté ce ticket', () => {
        f.statut = 'ok'; f.ticket = t.id;
        S.tags[t.id] = 'Fiche ' + f.prenom;
        S.fiches = S.fiches.filter(x => x.id !== f.id);
        sauverLocal();
      });
      return;
    }
    else if(act === 'rapnon'){ const c = candidat(); if(c){ S.tags[c.id] = 'Ticket écarté'; sauverLocal(); } }
    else if(act === 'rapsans'){
      S.fiches = S.fiches.filter(x => x.id !== a);
      sauverLocal();
      dire("Fiche close sans achat. Elle reste enregistrée dans Shopify.", true);
    }

    /* ── enregistrer ── */
    else if(act === 'creerexp'){
      const E = S.exp;
      const libelle = E.mode === 'paye' ? 'est enregistrée avec son achat'
                    : E.mode === 'apayer' ? 'est enregistrée, son ticket suivra'
                    : 'est enregistrée';
      const attente = (E.mode === 'apayer');
      const infos = { prenom:E.prenom.trim(), nom:E.nom.trim(), email:E.email.trim().toLowerCase() };
      const tk = parId(E.ticket);
      enregistrer(corpsDepuisExpress(), libelle, () => {
        if(tk) { S.tags[tk.id] = 'Fiche ' + infos.prenom; }
        if(attente) nouvelleFicheEnAttente(infos.prenom, infos.nom, infos.email);
        sauverLocal();
        remiseAZeroExpress();
        S.vue = 'comptoir'; haut();
        chargerTickets(true);
      });
      return;
    }
    else if(act === 'creer'){
      const C = S.coord;
      const attente = (S.vente === 'apayer');
      const infos = { prenom:C.prenom.trim(), nom:C.nom.trim(), email:C.email.trim().toLowerCase() };
      const tk = parId(S.ticketVente);
      enregistrer(corpsDepuisDiagnostic(), 'a son diagnostic au dossier', () => {
        if(S.vente === 'paye' && tk) S.tags[tk.id] = 'Fiche ' + infos.prenom;
        if(attente) nouvelleFicheEnAttente(infos.prenom, infos.nom, infos.email);
        sauverLocal();
        remiseAZeroDiag();
        S.vue = 'comptoir'; haut();
        chargerTickets(true);
      });
      return;
    }

    rendre();
  });

  racine.addEventListener('input', e => {
    const t = e.target;
    if(t.matches('[data-note]')){ S.notes[t.dataset.note] = t.value; sauverLocal(); return; }
    if(t.matches('[data-coord]')){ S.coord[t.dataset.coord] = t.value; return; }
    if(t.matches('[data-corr]')){ S.correction[t.dataset.corr] = t.value; return; }
    if(t.matches('[data-num]')){ S.numTicket = t.value; S.numEtat = ''; return; }
    if(t.matches('[data-exp]')){
      S.exp[t.dataset.exp] = t.value;
      const b = document.getElementById('bexp');
      if(b) b.disabled = !(emailOk(S.exp.email) && S.exp.prenom.trim() && S.exp.consent);
      return;
    }
    if(t.id === 'cptRech'){
      S.rech = t.value;
      chargerBase(false);
      if(S.vue !== 'clients'){ S.vue = 'clients'; rendre(); const r = document.getElementById('cptRech'); if(r){ r.focus(); r.value = S.rech; } }
      else rendre();
    }
  });

  racine.addEventListener('keydown', e => {
    if(e.key === 'Enter' && e.target.id === 'cptCode'){
      e.preventDefault();
      const bouton = racine.querySelector('[data-a="deverrouiller"]');
      if(bouton) bouton.click();
    }
  });

  function haut(){ const m = racine.querySelector('.main'); if(m) m.scrollTop = 0; }

  /* ── démarrage ─────────────────────────────────────────────────────── */
  function demarrer(){
    rendre();
    if(!S.ouvert) return;
    chargerTickets(true);
    chargerBase(false);
    clearInterval(rafraichisseur);
    /* La caisse est relue toutes les 90 secondes, mais seulement quand on
       regarde le comptoir et que rien n'est en cours de saisie. */
    rafraichisseur = setInterval(() => {
      if(document.hidden || S.occupe) return;
      if(S.vue !== 'comptoir' && S.vue !== 'tableau') return;
      S.ticketsEtat = 'inconnu';
      chargerTickets(true);
    }, 90000);
  }

  S.d = dNeuf();
  demarrer();
})();